import {RemovedSlot} from "./RemovedSlot";
import {IdKey} from "../../../../typescript-plugin/entities/IdKey";
import {Key} from "../../../../typescript-plugin/entities/Key";
import {IEntity} from "../../../../typescript-plugin/entities/IEntity";
import {RemovedSlots} from "./RemovedSlots";
import {Slot} from "../calendar/Slot";

export class Unavailability implements IEntity{

    public id:string;
    public vanId:string;
    public removedSlots:RemovedSlots;

    constructor(){
        this.removedSlots = new RemovedSlots();
    }

    public Key(): Key {
        return new IdKey(this.id);
    }

    public Serialize(): {} {
        let data = this.ToPersistable();
        data['removedSlots'] = this.removedSlots.Serialize();
        return data;
    }

    public Deserialize(data: {}): void {
        this.ToEntity(data);
        this.removedSlots.Deserialize(data['removedSlots']);
    }

    public ToPersistable(): {} {
        return {
            id: this.id,
            vanId: this.vanId,
        };
    }

    public ToEntity(data: {}): void {
        this.id = data['id'];
        this.vanId = data['vanId'];
    }

    public Slots():Array<Slot>{
        let slots:Array<Slot> = [];
        for(let removedSlot of this.removedSlots.Value()){
            slots.push(removedSlot.slot);
        }
        return slots;
    }

    public AsFake():Unavailability{
        this.id = "id";
        this.vanId = "vanId";
        this.removedSlots.Value().push(new RemovedSlot().AsFake());
        this.removedSlots.Value().push(new RemovedSlot().AsFake());
        return this;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/leasing/unaivailability/Unavailability.ts